<template>
  <div>
    <!-- List -->
    <div>
      <vs-table
        id="product_list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1" @onchange="handleChangePage"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th>First Name</vs-th>
          <vs-th>Last Name</vs-th>
          <vs-th>Email</vs-th>
          <vs-th>Phone Number</vs-th>
          <vs-th>{{module_name}}</vs-th>
          <vs-th>Message</vs-th>
          <vs-th>Date</vs-th>
          <vs-th>Proof File</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">{{ tr.first_name || '-' }} </vs-td>
            <vs-td class="text-left">{{ tr.last_name || '-' }} </vs-td>
            <vs-td class="text-left">{{ tr.email || '-' }} </vs-td>
            <vs-td class="text-left">{{ tr.mobile_number ? tr.mobile_number.country_code + ' ' + tr.mobile_number.mobile_number : '-' }} </vs-td>
            <vs-td class="text-left">{{ tr.gurudwara ? tr.gurudwara.name : '-' }} </vs-td>
            <vs-td class="text-left cursor-pointer">
              <span class="cursor-pointer" @click="openDetailModal(tr)" v-tooltip="{ content: `View Gurudwara Onboard` }">
                {{ tr.message || '-' }}
              </span>
            </vs-td>
            <vs-td>
              <span>{{ moment(tr.createdAt).local().format('Do MMMM YYYY, h:mm:ss A') }}</span>
            </vs-td>
            <vs-td class="text-left">
              <vs-button v-if="tr.proof_file">
                <a :href="tr.proof_file" class="text-white" target="_blank">View File</a>
              </vs-button>
              <div v-else>Proof File Not Uploaded</div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <!-- Detail Modal -->
    <vs-popup :active.sync="isDetailModalActive" title="Gurudwara Onboard Details" button-accept="Close" @accept="isDetailModalActive = false" width="400px">
      <div v-if="selectedRecord" class="space-y-3">
        <!-- First Name -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">First Name:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.first_name || '-' }}</span>
        </div>

        <!-- Last Name -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Last Name:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.last_name || '-' }}</span>
        </div>

        <!-- Email -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Email:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.email || '-' }}</span>
        </div>

        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Phone Number:</span>
          <span class="text-lg font-semibold text-gray-800">
            {{ selectedRecord.mobile_number ? selectedRecord.mobile_number.country_code + ' ' + selectedRecord.mobile_number.mobile_number : '-' }}</span
          >
        </div>

        <!-- Gurudwara -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Gurudwara:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.gurudwara ? selectedRecord.gurudwara.name : '-' }}</span>
        </div>

        <!-- Message -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Message:</span>
          <span class="text-lg font-semibold text-gray-800">{{ selectedRecord.message || '-' }}</span>
        </div>

        <!-- Date -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Date:</span>
          <span class="text-lg font-semibold text-gray-800">{{ moment(selectedRecord.createdAt).local().format('Do MMMM YYYY, h:mm:ss A') }}</span>
        </div>

        <!-- Proof File -->
        <div class="flex gap-1 items-center border-b border-gray-200 pb-1">
          <span class="text-sm text-gray-500 font-medium">Proof File:</span>
          <vs-button v-if="selectedRecord.proof_file">
            <a :href="selectedRecord.proof_file" class="text-white" target="_blank">View File</a>
          </vs-button>
          <div v-else class="text-lg font-semibold text-gray-800">Proof File Not Uploaded</div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'OrganizationOnboardList',

  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'Organization Onboard',
    isDetailModalActive: false,
    selectedRecord: null
  }),

  computed: {
    ...mapState('gurudwaraOnboard', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  methods: {
    moment,
    ...mapActions('gurudwaraOnboard', {
      get: 'get'
    }),

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    getData() {
      this.get({
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    openDetailModal(record) {
      this.selectedRecord = record
      this.isDetailModalActive = true
    }
  },

  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#product_list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#product_list > .con-vs-loading')
      }
    },

    page() {
      this.getData()
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
